<template>
	<div
		:class="[
			'timelineEventBody font-body-s-medium flex h-full w-full flex-nowrap items-center',
			{
				'px-03': !fullWidth && !simplified && !shouldShowNotesIcon,
				'pl-03 pr-01': !fullWidth && !simplified && shouldShowNotesIcon,
				'px-02': !fullWidth && simplified,
				'justify-between': shouldShowSuffix
			}
		]"
	>
		<div class="eventBody flex h-full w-full items-center overflow-hidden">
			<!-- Slot for entire rectangle of the event (excluding depth suffix) -->
			<slot v-if="slots.body" name="body">
				{{ event.name }}
			</slot>

			<span v-if="slots.bodyContent" class="overflow-hidden text-ellipsis whitespace-nowrap">
				<!-- Slot just for the label of the event -->
				<slot name="bodyContent">
					{{ event.name }}
				</slot>
			</span>
		</div>

		<div v-if="shouldShowSuffix" class="suffixWrapper ml-03 flex h-full items-center gap-03">
			<div v-if="shouldShowDepthAmount" class="flex h-full items-center">
				<!-- Slot for depth suffix -->
				<slot name="depthSuffix">{{ event.discount_depth }}%</slot>
			</div>

			<div v-if="shouldShowNotesIcon" class="flex h-full items-center text-ink-87">
				<NoteIcon />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { isFinite } from '@bluebrick/saas-ui'
import { computed, useSlots } from 'vue'
import NoteIcon from '@/common/components/NoteIcon.vue'
import type { EventDataWithStore } from '@/types'

const props = defineProps<{
	event: EventDataWithStore
	fullWidth?: boolean
	simplified?: boolean
}>()

const slots = useSlots()

const shouldShowDepthAmount = computed(() => isFinite(props.event.discount_depth) && props.event.discount_depth > 0)
const shouldShowNotesIcon = computed(() => props.event.notes && props.event.notes.length > 0)
const shouldShowSuffix = computed(() => shouldShowDepthAmount.value || shouldShowNotesIcon.value)
</script>

<style lang="scss" scoped>
.timelineEventBody {
	container-type: inline-size;
}

.suffixWrapper {
	display: none;
}

@container (min-width: 62px) {
	.suffixWrapper {
		display: flex;
	}
}
</style>
